import type { MomSalaryReportPeriodOption } from './types';
import { formatMoney } from '../reports/formatters';

export const getDefaultBasePeriod = (
  periods: MomSalaryReportPeriodOption[],
  reportingPeriodId: number | null
): number | null => {
  if (periods.length < 2) return reportingPeriodId;

  const reportingIndex = periods.findIndex((period) => period.id === reportingPeriodId);
  return periods[reportingIndex + 1]?.id ?? periods[1]?.id ?? null;
};

export const getVarianceColor = (value: number): 'error.main' | 'success.main' | 'text.primary' => {
  if (value > 0) return 'error.main';
  if (value < 0) return 'success.main';
  return 'text.primary';
};

export const formatVariance = (value: number): string => {
  const formatted = formatMoney(Math.abs(value));
  return value > 0 ? `+${formatted}` : value < 0 ? `-${formatted}` : formatted;
};
